var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCocktail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2 55.8l7.7 49.2s2 4.1 10.5 6.2c0 0 14.5 3.9 25.5-3.2l3.1-2.9 7.8-45.2 4 10 6.9-2.9 3.7-6.2 2.1-4.8-1.4-7.8s-2.7-4.1-3.2-4.5c-.4-.4-6.4-3.9-6.4-3.9h-7.2L80.2 41l-5.9 4.3-5-.9-9.5-.7L46.5 45l-9.2 3.2-5 4.6-.1 3z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 102c.1 0 .2.1.3.1-.1 0-.2-.1-.3-.1zM58.4 102.4c-.1 0-.2-.1-.3-.1 0 .1.1.1.3.1-.1 0-.1 0 0 0z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 60.1c-4.8 3.4-13.9 5.7-24.5 5.7-14.5 0-26.4-4.4-27.8-10-.1-.4-.1-.8-.1-1.1 0-6.1 12.5-11.1 28-11.1 5.6 0 10.9.7 15.3 1.8",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 60.1c-4.8 3.4-13.9 5.7-24.5 5.7-14.5 0-26.4-4.4-27.8-10-.1-.4-.1-.8-.1-1.1 0-6.1 12.5-11.1 28-11.1 5.6 0 10.9.7 15.3 1.8M33.7 65.3l5 32.2",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2 107s-4.6 5.2-17.8 5.1c-13.2.1-17.8-5.1-17.8-5.1",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2 107s-4.6 5.2-17.8 5.1c-13.2.1-17.8-5.1-17.8-5.1M85.5 65.8l-3.6 21.8M81 92.2l-1.1 6.7",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 54.9c-3.3-.8-7.6-1.3-12.2-1.3-10.5 0-19.1 2.5-19.1 5.7 0 3.1 8.5 5.7 19.1 5.7 5.8 0 12.2-1 15.7-2.2-1-1.8-1.7-3.6-2.3-5.5-.4-.9-1.2-1.6-1.2-2.4z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8 58.5c-2.1-8.4 3-17 11.4-19.1 8.4-2.1 17 3 19.1 11.4 1.9 7.5-1.9 15.1-8.7 18.2-.8.4-1.7.7-2.6.9",
    stroke: "#FFCBBD",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7 46.7l1.3 4.8M89 58.2l1.3 4.7M96.1 52.5l-4.7 1.4M84.6 55.8l-4.7 1.4M92.1 47.4l-2.4 4.4M95.4 58.9l-4.3-2.4M84.9 53.1l-4.3-2.3",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7 58.2l-4.6-31.5s-.6-4.3-4.1-2.5c-4.4 2.3-11.6 6-11.6 6",
    stroke: "#5D21D2",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8 69.4c-.3-.2-.6-.2-.9-.1-7.1 3-14.2 3.5-17.5 3.5-3.3 0-10.4-.5-17.5-3.5-.3-.1-.6-.1-.9.1-.3.2-.4.5-.3.8l3.7 24.2c0 .5.5 4.1 4.9 5.9.1 0 .2.1.3.1.2.1.4.1.6.2.1 0 .2.1.3.1 2.1.6 4.2.9 5.9 1.1 3.6.3 8.2.1 13.3-1.6 4.3-1.8 4.7-5.3 4.8-5.8l3.7-24.2c0-.3-.1-.6-.4-.8z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCocktail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cocktail.687447ccf01dc049ca16a88c2beea1d7.svg";